/* DARKGROUND DESIGN SYSTEM · extras
   - Smooth open/close for dropdowns: the contents list (details.dg-contents) and FAQ (.dg-acc details).
   - Essential Upsell styling hooks (cart drawer, cart page and product page slot), and its prices shown with a
     decimal comma like the rest of the site (the app always prints "€16.00").
   - [data-dg-add-all]: adds products (skips what is already in the cart), applies [data-dg-code] if any
     (keeping other valid codes), refreshes the theme's cart drawer and opens it.
   - [data-dg-vpicker]: edition / variant picker. Keeps pickers, hidden theme form, buy form, prices
     ([data-dg-price]), compare-at prices ([data-dg-compare]) and kit buttons in sync.
   - [data-dg-zoom]: opens an image in a lightbox (only where a link asks for it).
*/
(function () {
  'use strict';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- dropdowns ---------- */
  function animate(d, body, opening) {
    d.dataset.dgAnimating = '1';
    if (opening) d.open = true;
    var start = opening ? 0 : body.scrollHeight;
    var end = opening ? body.scrollHeight : 0;
    body.classList.add('dg-details-anim');
    body.style.transition = 'none';
    body.style.height = start + 'px';
    body.style.opacity = opening ? '0' : '1';
    void body.offsetHeight;
    body.style.transition = 'height .45s cubic-bezier(.2, .7, .2, 1), opacity .35s ease';
    body.style.height = end + 'px';
    body.style.opacity = opening ? '1' : '0';
    var finished = false;
    function done(e) {
      if (e && (e.target !== body || e.propertyName !== 'height')) return;
      if (finished) return;
      finished = true;
      body.removeEventListener('transitionend', done);
      if (!opening) d.open = false;
      body.style.height = '';
      body.style.opacity = '';
      body.style.transition = '';
      body.classList.remove('dg-details-anim');
      delete d.dataset.dgAnimating;
    }
    body.addEventListener('transitionend', done);
    setTimeout(function () { done(); }, 700);
  }
  function bindDetails(root) {
    (root || document).querySelectorAll('details.dg-contents, .dg-acc details').forEach(function (d) {
      if (d.dataset.dgBound) return;
      d.dataset.dgBound = '1';
      var s = d.querySelector('summary');
      var body = s ? s.nextElementSibling : null;
      if (!s || !body || reduced) return;
      s.addEventListener('click', function (e) {
        e.preventDefault();
        if (d.dataset.dgAnimating) return;
        animate(d, body, !d.open);
      });
    });
  }

  /* ---------- Essential Upsell styling hooks ---------- */
  var ESS_SCOPES = 'essential-upsell-cart-portal, essential-upsell-cross-sell-app-block, [data-dg-upsell-slot], [data-dg-essential-scope]';
  var TITLE = /^(make your bundle|frequently bought together|complete your|you may also like|get bundle discount|customers also bought|bundle and save)/i;
  var PILL = /^-?\s*\d+\s*%\s*off$|^save\s+\d+\s*%$/i;
  var DOT_PRICE = /^([€$£]\s?)(\d{1,3}(?:,\d{3})*|\d+)\.(\d{2})(\s?[A-Z]{3})?$/;
  function isCardScope(scope) {
    return scope.tagName === 'ESSENTIAL-UPSELL-CART-PORTAL' || scope.tagName === 'ESSENTIAL-UPSELL-CROSS-SELL-APP-BLOCK' || scope.hasAttribute('data-dg-essential-scope');
  }
  function commaPrice(el, txt) {
    var m = txt.match(DOT_PRICE);
    if (!m) return;
    var fixed = m[1] + m[2].replace(/,/g, '.') + ',' + m[3] + (m[4] || '');
    if (fixed !== txt) el.textContent = fixed;
  }
  function addButtons(node) {
    var n = 0;
    node.querySelectorAll('button').forEach(function (b) { if (/\badd\b|claim/i.test((b.textContent || '').trim())) n++; });
    return n;
  }
  function tagEssential() {
    document.querySelectorAll(ESS_SCOPES).forEach(function (scope) {
      scope.querySelectorAll('*').forEach(function (el) {
        var txt = (el.textContent || '').trim();
        if (el.children.length === 0 && txt && DOT_PRICE.test(txt)) commaPrice(el, txt);
        if (el.dataset.dgEss) return;
        if (el.tagName === 'BUTTON') {
          el.dataset.dgEss = '1';
          if (/\badd\b|claim/i.test(txt)) {
            el.classList.add('dg-ess-add');
            if (isCardScope(scope)) {
              var card = el.parentElement;
              for (var i = 0; i < 6 && card && card !== scope && !card.querySelector('img'); i++) card = card.parentElement;
              /* only a single offer gets the card frame; if its image is not there yet, try again on the next change */
              if (card && card !== scope && card.querySelector('img') && addButtons(card) === 1) card.classList.add('dg-ess-card');
              else delete el.dataset.dgEss;
            }
          } else if (!txt) {
            el.classList.add('dg-ess-arrow');
          }
          return;
        }
        if (el.children.length === 0 && txt) {
          if (PILL.test(txt)) { el.dataset.dgEss = '1'; el.classList.add('dg-ess-pill'); }
          else if (TITLE.test(txt)) { el.dataset.dgEss = '1'; el.classList.add('dg-ess-title'); }
        }
      });
    });
    document.querySelectorAll('.dg-ess-card').forEach(function (c) { if (addButtons(c) > 1) c.classList.remove('dg-ess-card'); });
  }
  var essQueued = false;
  function queueEssential() {
    if (essQueued) return;
    essQueued = true;
    requestAnimationFrame(function () { essQueued = false; tagEssential(); });
  }
  function watchEssential() {
    tagEssential();
    var targets = [document.querySelector('cart-drawer-component'), document.querySelector('[data-dg-upsell-slot]'), document.getElementById('MainContent')];
    targets.forEach(function (t) {
      if (!t || t.dataset.dgEssWatch) return;
      t.dataset.dgEssWatch = '1';
      new MutationObserver(queueEssential).observe(t, { childList: true, subtree: true, characterData: true });
    });
  }

  /* ---------- edition / variant picker ---------- */
  function selectVariant(id, price, compare) {
    document.querySelectorAll('[data-dg-vpicker] [data-variant-id]').forEach(function (b) {
      b.setAttribute('aria-checked', b.getAttribute('data-variant-id') === id ? 'true' : 'false');
    });
    document.querySelectorAll('#MainContent > .shopify-section[id$="__main"] form[action*="/cart/add"] input[name="id"], .dg-buy__form input[name="id"]').forEach(function (input) {
      input.value = id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (price) document.querySelectorAll('[data-dg-price]').forEach(function (el) { el.textContent = price; });
    document.querySelectorAll('[data-dg-compare]').forEach(function (el) {
      if (compare) { el.textContent = compare; el.hidden = false; } else { el.textContent = ''; el.hidden = true; }
    });
    document.querySelectorAll('[data-dg-add-all][data-dg-self]').forEach(function (b) {
      var ids = (b.getAttribute('data-dg-add-all') || '').split(',');
      ids[0] = id;
      b.setAttribute('data-dg-add-all', ids.join(','));
    });
    try { var u = new URL(window.location.href); u.searchParams.set('variant', id); window.history.replaceState(null, '', u.toString()); } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    var opt = e.target.closest ? e.target.closest('[data-dg-vpicker] [data-variant-id]') : null;
    if (!opt || opt.disabled) return;
    e.preventDefault();
    selectVariant(opt.getAttribute('data-variant-id'), opt.getAttribute('data-price'), opt.getAttribute('data-compare'));
  });

  /* ---------- lightbox (only for links that ask for it) ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('[data-dg-zoom]') : null;
    if (!a) return;
    var dlg = document.getElementById('dg-lightbox');
    if (!dlg) {
      if (typeof HTMLDialogElement === 'undefined') return;
      dlg = document.createElement('dialog');
      dlg.id = 'dg-lightbox';
      dlg.className = 'dg-lightbox';
      dlg.innerHTML = '<button type="button" class="dg-lightbox__close" aria-label="Close">&times;</button><img alt="">';
      document.body.appendChild(dlg);
      dlg.addEventListener('click', function (ev) { if (ev.target === dlg || ev.target.closest('.dg-lightbox__close')) dlg.close(); });
    }
    e.preventDefault();
    var img = dlg.querySelector('img');
    img.src = a.getAttribute('href');
    img.alt = a.getAttribute('data-alt') || '';
    dlg.showModal();
  });

  /* ---------- add products, refresh and open the cart drawer ---------- */
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-dg-add-all]') : null;
    if (!b || b.disabled) return;
    e.preventDefault();
    var ids = (b.getAttribute('data-dg-add-all') || '').split(',').map(function (x) { return parseInt(x, 10); }).filter(Boolean);
    var code = (b.getAttribute('data-dg-code') || '').trim();
    if (!ids.length) return;
    var itemsEl = document.querySelector('cart-items-component[data-drawer]') || document.querySelector('cart-items-component');
    var sectionId = itemsEl && itemsEl.dataset ? itemsEl.dataset.sectionId : '';
    var drawer = document.querySelector('cart-drawer-component');
    b.disabled = true;
    b.classList.add('is-loading');
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inCart = (cart.items || []).map(function (i) { return i.variant_id; });
        var toAdd = ids.filter(function (id) { return inCart.indexOf(id) < 0; });
        var step = toAdd.length
          ? postJSON('/cart/add.js', { items: toAdd.map(function (id) { return { id: id, quantity: 1 }; }) })
          : Promise.resolve();
        return step.then(function () {
          var body = {};
          if (code) {
            var keep = (cart.discount_codes || []).filter(function (d) {
              return d.applicable && String(d.code).toUpperCase() !== code.toUpperCase();
            }).map(function (d) { return d.code; });
            body.discount = keep.concat([code]).join(',');
          }
          if (sectionId) { body.sections = sectionId; body.sections_url = window.location.pathname; }
          return postJSON('/cart/update.js', body);
        });
      })
      .then(function (cart) {
        if (!drawer || !sectionId) { window.location.href = '/cart'; return; }
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'dg-add', data: { source: 'dg-add', itemCount: cart.item_count, sections: cart.sections || {} } }
        }));
        if (typeof drawer.showDialog === 'function') drawer.showDialog();
        else if (typeof drawer.open === 'function') drawer.open();
      })
      .catch(function () { window.location.href = '/cart'; })
      .finally(function () { b.disabled = false; b.classList.remove('is-loading'); });
  });

  /* ---------- sticky buy bar: on phones show the name up to the dash (CSS decides which one is visible) ---------- */
  function shortStickyNames() {
    document.querySelectorAll('.dg-sticky__name:not(.dg-sticky__name--short):not([data-dg-short])').forEach(function (n) {
      n.setAttribute('data-dg-short', '1');
      var full = (n.textContent || '').trim();
      var short = full.split(' – ')[0].split(' - ')[0].trim();
      if (!short || short === full) return;
      var s = document.createElement('span');
      s.className = 'dg-sticky__name dg-sticky__name--short';
      s.textContent = short;
      n.classList.add('dg-sticky__name--full');
      n.insertAdjacentElement('afterend', s);
    });
  }

  function setup(root) {
    bindDetails(root);
    watchEssential();
    shortStickyNames();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setup(document); });
  } else {
    setup(document);
  }
  document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
})();
